import { Toaster } from 'sonner';
import { useTranslation } from 'react-i18next';
import { AlertCircle, AlertTriangle, Check, Info, X } from 'lucide-react';
import { ICON_SIZE } from '../design-system';
import useMobileShell from '../hooks/useMobileShell';
import './ReedleToaster.css';

// Keep Sonner in charge of timers, live announcements, stacking and gestures.
export default function ReedleToaster() {
  const { t } = useTranslation('common');
  const isPhone = useMobileShell();

  return (
    <Toaster
      className={isPhone ? 'reedle-toaster reedle-toaster--phone' : 'reedle-toaster'}
      position="bottom-center"
      gap={12}
      visibleToasts={3}
      offset="24px"
      mobileOffset="16px"
      icons={{
        success: <Check size={ICON_SIZE.sm} aria-hidden="true" />,
        error: <AlertCircle size={ICON_SIZE.sm} aria-hidden="true" />,
        warning: <AlertTriangle size={ICON_SIZE.sm} aria-hidden="true" />,
        info: <Info size={ICON_SIZE.sm} aria-hidden="true" />,
        close: <X size={ICON_SIZE.sm} aria-hidden="true" />,
      }}
      toastOptions={{ closeButtonAriaLabel: t('close') }}
    />
  );
}
